import { isSignal, Resource } from '@angular/core';

export function isResource<T>(value: unknown): value is Resource<T> {
  return isSignal((value as unknown as Resource<T>)?.value)
      && isSignal((value as unknown as Resource<T>)?.status)
      && isSignal((value as unknown as Resource<T>)?.isLoading)
      && isSignal((value as unknown as Resource<T>)?.error)
      && !!(value as unknown as Resource<T>)?.hasValue
}
